import { create } from 'zustand'

/**
 * Transient, repeatable app notice rendered as an FTUE-styled coachmark.
 *
 * Deliberately separate from the FTUE engine: FTUE steps are account-persisted
 * and fire once per user, whereas these notices must show EVERY time the
 * triggering action happens (e.g. opening Job Agent without a resume). The store
 * keeps just the copy plus the anchor to point at; resolution and rendering live
 * in `AppNoticeCoachmark`, mounted once in the app layout so the notice survives
 * the route change that usually raises it.
 */
export interface AppNotice {
  body: string
  /** FTUE anchor id the coachmark points at (see `useFtueAnchor` registrations). */
  anchorId: string
}

interface AppNoticeState {
  notice: AppNotice | null
  showNotice: (notice: AppNotice) => void
  clearNotice: () => void
}

export const useAppNoticeStore = create<AppNoticeState>((set) => ({
  notice: null,
  showNotice: (notice) => set({ notice }),
  clearNotice: () => set({ notice: null }),
}))
